package com.iregained.site.components.sections.promo.styles

import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

val PromoContainerStyle = CssStyle {
    base {
        Modifier.fillMaxWidth()
    }
}

val PromoGridStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().maxWidth(1200.px).gap(40.px)
    }
}

// Updated to look like a native branded card instead of a generic white box
val PromoIframeContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .borderRadius(16.px)
            .overflow(Overflow.Hidden) // Keeps the iframe constrained to the rounded corners
            // Replaces the stark white box with a softer, branded container
            .backgroundColor(Colors.White)
            // Adds a brand-colored top accent (matches your Brochure section)
            // Note: Since we don't have direct access to the dynamic palette here,
            // we use the standard brand hex, or you can apply this specific modifier directly in the Composable.
//            .borderTop(8.px, LineStyle.Solid, argb(1f, 46f/255f, 139f/255f, 87f/255f)) // Example SeaGreen/Brand color
            // Softer, more modern shadow
            .boxShadow(0.px, 20.px, 45.px, 0.px, argb(0.15f, 0f, 0f, 0f))
    }
}